import React from "react"

import App from "../components/app"
import DecorativeHeader from "../components/decorative-header"
import MaxWidthContainer from "../components/max-width-container"
import Footer from "../components/footer"

export default function Layout({ children }) {
  return (
    <App>
      <DecorativeHeader />
      <MaxWidthContainer>
        {children}
      </MaxWidthContainer>
      <Footer />
    </App>
  )
}
